import { render, staticRenderFns } from "./AwardsIssued.vue?vue&type=template&id=1070767f&"
import script from "./AwardsIssued.vue?vue&type=script&lang=js&"
export * from "./AwardsIssued.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports